import ConstantHelper from "~helpers/ConstantHelper";

// export const [settingsMessageTemplateType, settingsMessageTemplateTypeOptions, settingsMessageTemplateTypeMap] =
//   ConstantHelper.typify({
//     SURVEY_ANNOUNCEMENT: "Survey Announcement",
//     SURVEY_REANNOUNCEMENT: "Survey Re-Announcement",
//     TICKET_CREATE_CUSTOMER: "Ticket Create Customer",
//     TICKET_SHARE: "Ticket Share",
//     TICKET_CREATE_AGENT: "Ticket Create Agent",
//     TICKET_RESOLVED: "Ticket Resolved",
//     TICKET_ASSIGNED_USER_CHANGED_CUSTOMER: "Ticket Assigned User Changed Customer",
//     TICKET_ASSIGNED_USER_CHANGED_AGENT: "Ticket Assigned User Changed Agent",
//     TICKET_CATEGORY_CHANGED_CUSTOMER: "Ticket Category Changed Customer",
//     TICKET_UPDATED: "Ticket Updated",
//     TICKET_COMMENT_AGENTS: "Ticket Comment Agents",
//     TICKET_COMMENT_CUSTOMER: "Ticket Comment Customer",
//   });

// export const [
//   settingsReservationMessageTemplateType,
//   settingsReservationMessageTemplateTypeOptions,
//   settingsReservationMessageTemplateTypeMap,
// ] = ConstantHelper.typify({
//   RESERVATION_CREATE: "Reservation Create",
//   RESERVATION_DELETE: "Reservation Delete",
//   RESERVATION_UPDATE: "Reservation Update",
// });

export const [settingsLanguage, settingsLanguageOptions, settingsLanguageMap] = ConstantHelper.typify({
  EN: "constants.languages.english",
  TR: "constants.languages.turkish",
  DE: "constants.languages.german",
  GR: "constants.languages.greek",
  AR: "constants.languages.arabic",
  UA: "constants.languages.ukrainian",
  RU: "constants.languages.russian",
  PE: "constants.languages.persian",
  FR: "constants.languages.french",
});

export const [settingsTemplateFormat, settingsTemplateFormatOptions, settingsTemplateFormatMap] = ConstantHelper.typify(
  {
    HTML: "HTML",
    PLAIN: "Plain",
    MARKDOWN: "Markdown",
  }
);

export const [settingsTemplatePlatformType, settingsTemplatePlatformTypeOptions, settingsTemplatePlatformTypeMap] =
  ConstantHelper.typify({
    EMAIL: "constants.settingsTemplatePlatformType.email",
    SMS: "constants.settingsTemplatePlatformType.sms",
    PUSH_NOTIFICATION: "constants.settingsTemplatePlatformType.pushNotification",
  });

export const [guideType, guideTypeOptions, guideTypeMap] = ConstantHelper.typify({
  Guide: "constants.guideType.guide",
  Tooltip: "constants.guideType.tooltip",
});

export const [fileType, fileTypeOptions, fileTypeMap] = ConstantHelper.typify({
  Image: "constants.fileType.image",
  File: "constants.fileType.file",
});
